import moment from "moment";

/**
 * formatDate as per the format params
 * @param dateFormat date format default date format is 'DD MMMM YYYY hh:mm A'
 * @returns a formate date string
 */
export const formatDate = (dateString, dateFormat = "DD MMMM YYYY hh:mm A") => {
  return moment(dateString).format(dateFormat);
};
